import type { ComboboxOption } from "@rumbledirect/ui-v2";
import { z } from "zod";

export type EndOfContract = "yes" | "no";

export const END_OF_CONTRACT_LABEL = "Einde contract < 6 mnd";
export const END_OF_CONTRACT_OPTIONS: readonly ComboboxOption[] = [
  { value: "all", label: "Alle" },
  { value: "yes", label: "Ja" },
  { value: "no", label: "Nee" },
];

/** Rule IDs are supplied by the served layout, never by the URL. */
export const dossierFilterOptionsSchema = z
  .object({
    matchedRule: z.object({ ruleIds: z.array(z.string().uuid()) }).optional(),
  })
  .optional()
  .catch(undefined);

export function toEndOfContract(value: unknown): EndOfContract | undefined {
  return value === "yes" || value === "no" ? value : undefined;
}

/** Both pages use the same ANY/NONE translation, including the empty-layout guard. */
export function toEndOfContractParams(
  selection: EndOfContract | undefined,
  ruleIds: readonly string[],
): { matchedRule?: string[]; excludeMatchedRule?: string[] } {
  if (ruleIds.length === 0) return {};
  if (selection === "yes") return { matchedRule: [...ruleIds] };
  if (selection === "no") return { excludeMatchedRule: [...ruleIds] };
  return {};
}
